import React from "react";
import classnames from "@utils/classnames";
import styles from "./box.module.scss";

const Box = ({ texture, color, thin, thick, children, className }) => {
  return (
    <div
      className={classnames(
        styles.box,
        styles[color],
        {
          [styles.thin]: thin,
          [styles.thick]: thick,
          [styles.arrow]: texture === "arrow",
          [styles.spot]: texture === "spot",
          [styles.cloud]: texture === "cloud",
          [styles.slash]: texture === "slash"
        },
        className
      )}
    >
      <div className={styles.texture}></div>
      <div className={styles.body}>{children}</div>
    </div>
  );
};

export default Box;
